/**
 * Mirror of backend `kycDocumentCatalog.js` for web Payout Capture picker.
 */

export const KYC_DOCUMENT_CATALOG = [
  { id: 'au_drivers_licence', group: 'australian', label: "Driver's licence", documentType: 'drivers_licence' },
  { id: 'au_birth_certificate', group: 'australian', label: 'Birth certificate', documentType: 'birth_certificate' },
  { id: 'au_passport', group: 'australian', label: 'Passport', documentType: 'passport' },
  { id: 'au_medicare', group: 'australian', label: 'Medicare', documentType: 'medicare' },
  {
    id: 'au_citizenship_certificate',
    group: 'australian',
    label: 'Citizenship certificate',
    documentType: 'citizenship_certificate',
  },
  { id: 'au_damaged_document', group: 'australian', label: 'Damaged document', documentType: 'damaged_document' },
  { id: 'intl_passport', group: 'international', label: 'Passport', documentType: 'intl_passport' },
  { id: 'intl_visa', group: 'international', label: 'Visa', documentType: 'visa' },
  { id: 'no_document', group: 'none', label: 'No document', documentType: 'none' },
]

export const KYC_DOCUMENT_GROUPS = [
  { id: 'australian', title: 'Australian documents' },
  { id: 'international', title: 'International documents' },
  { id: 'none', title: 'No document' },
]

export function optionById(id) {
  return KYC_DOCUMENT_CATALOG.find((o) => o.id === id) || null
}
